// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2qrz9","title":"card_title__37S3T","inActive":"card_inActive__pnOdd"};